export const methodology = {
  text: "Metodología",
  title1: "Nossa Abordagem",
  paragraph1:
    "No início de 2016, a equipe GDHM, juntamente com representantes de mais de 20 países e mais de 50 agências e organizações internacionais, projetou a versão 1.0 do Global Digital Health Index (GDHI)." +
    " Em 2022, o recurso passou por um processo de revisão e redesenho de indicador e plataforma de um ano para alinhar os indicadores com a Estratégia Global de Saúde Digital da OMS como um complemento ao Atlas de Saúde Digital da OMS e inclui um foco maior em IA, " +
    "equidade, gênero e Cobertura Universal de Saúde. Além disso, o nome foi alterado para Global Digital Health Monitor (GDHM) para articular o valor da ferramenta em fornecer uma plataforma para monitorar o progresso da saúde digital em nível nacional, regional e global." +
    " O GDHM atualizado inclui visualizações de país de monitoramento de desempenho ano a ano, visualizações regionais e comparações de país para país.",
  bulletin: {
    title: "Para desenvolver os indicadores, a equipa GDHM:",
    line1:
      "Realizou uma revisão geral dos dados globais disponíveis através de organizações multilaterais.",
    line2:
      "Mapeou os dados disponíveis através da revisão dos quadros e ferramentas existentes desenvolvidos por especialistas para ajudar os " +
      "profissionais e os países a avaliar a força e a maturidade de um ambiente favorável e relevante para a saúde digital.",
    line3:
      "Convocou especialistas em saúde digital para desenvolver casos de uso para o GDHM refinar e definir um conjunto inicial de indicadores " +
      "recomendados, vertidos numa lista de fácil gestão e utilização.",
  },
  paragraph2: "Lista de Indicadores GDHM - ",
  seeHere: "Veja aqui",

  title2: "Recolha e verificação de dados",
  paragraph3Start:
    "A equipe GDHM trabalha com parceiros nacionais e representantes do Ministério da Saúde que estão a liderar os esforços " +
    "de saúde digital nos seus respectivos países para reunir dados para cada país. Estes parceiros nacionais submetem os dados do seu país " +
    "através de um inquérito anual GDHM e selecionam a fase apropriada para cada indicador, bem como a fundamentação e evidência para apoiar " +
    "estas fases. A equipe GDHM verifica os dados reunidos antes de os publicar. Os dados mais amplos de saúde do ",
  paragraph3Link: "Indicadores de Desenvolvimento do Banco Mundial 2019",
  paragraph3End:
    "foram incluídos para contextualizar a maturidade em saúde digital.",

  title3: "Cálculo de médias e benchmarking",
  paragraph4:
    "O GDHM utiliza os principais indicadores em cada categoria para calcular a média geral do país. Embora os subindicadores sejam " +
    "incluídos para adicionar maior especificidade a indicadores GDHM específicos, estes não são usados no cálculo da Fase Componente ou das Médias " +
    "Globais ou do País. O GDHM permite que os países se comparem com a Média Global ou com uma fase geral específica.",
  title4: "Dados pré-preenchidos de fontes publicamente disponíveis",
  paragraph5:
    "Para os países que não concluíram uma pesquisa no Global Digital Health Monitor, os dados foram extraídos de informações publicamente disponíveis para pré-preencher os indicadores abaixo para dar uma noção geral de maturidade mais ampla do ecossistema digital em alinhamento com indicadores relevantes. Embora esses dados sirvam como um proxy para esses indicadores de saúde digital para os países, os dados preenchidos por funcionários do governo fornecem uma imagem mais precisa e robusta do progresso da saúde digital em cada país. Encorajamos os países que não enviaram dados completos a solicitar um link de país para fazê-lo o mais cedo possível.",
  indicators: {
    bulletin: {
      title:
        "Indicadores que usaram dados de proxy de fontes publicamente disponíveis para pré-preencher países que não concluíram uma pesquisa: ",
      line1:
        "Indicador 2a: A saúde é priorizada nas políticas nacionais de transformação digital e governança de dados",
      line2:
        "Indicador 4: Análise, planejamento e monitoramento de diversidade, equidade e direitos humanos incluídos nas estratégias e planos nacionais de saúde digital",
      line3:
        "Indicador 6a: participação do setor privado e investimentos em saúde digital",
      line4: "Indicador 7: quadro jurídico para proteção de dados (segurança)",
      line5:
        "Indicador 8: Leis ou regulamentos para privacidade, consentimento, confidencialidade e acesso a informações de saúde (Privacidade)",
      line6:
        "Indicador 9: Protocolo para regulamentar ou certificar dispositivos e/ou serviços de saúde - incluindo provisões para IA e algoritmos (em estágios mais altos de maturidade)",
      line7: "Indicador 17: prontidão da rede",
      line8:
        "Indicador 18: Planejamento e suporte para manutenção contínua da infraestrutura de saúde digital",
    },
    paragraph: {
      start: "As fontes de dados incluíram o ",
      govTech: "Indicador de Maturidade GovTech",
      GTMI: "(GTMI)",
      NRI: "Índice de prontidão de rede",
      GCI: "Índice Global de Cibersegurança",
      GSMA: "Índice de Conectividade Móvel GSMA",
      the: "a",
      andThe: "e a",
    },
  },
};
